module.exports = __webpack_public_path__ + "static/media/birdbrain3.4b2884be.jpg";